module.exports = __webpack_public_path__ + "img/27.7b91eeb7.png";